export default __webpack_public_path__ + "static/media/logo_funus.652c0314.svg";